import { createDomain } from 'effector';

const domain = createDomain('pages/pre-payment');

const $$prePaymentPage = {
    $charityLinked: domain.store<boolean>(false),
    $charitySelected: domain.store<boolean>(false),
    $wasGeneratedWithCharity: domain.store<boolean>(false),
    $youCompletedTextResource: domain.store<string>(''),
    $mustGoToModality: domain.store<boolean>(false),

    openMissingCharityModality: domain.event(),
    modalityCloseClick: domain.event(),
    modalityConfirmClick: domain.event(),
};

export default $$prePaymentPage;
